import SavedViewService from '@services/saved-view.service';
import GraphqlService from '@services/graphql.service';
import { CustomObjectsService } from '@shared/modules/custom-objects/services/custom-objects.service';
import { ProjectTemplateService } from 'app/modules/projects/project-template.service';
import { inject, Injectable } from '@angular/core';
import { ImageService } from '@services/image.service';
import { SavedFilterService } from '@services/saved-filter.service';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { EngagementsService } from 'app/modules/engagements/engagements.service';
import { PipelineService } from 'app/modules/projects/pipeline.service';

@Injectable({ providedIn: 'root' })
export class JupiterDataService {
  accountId: number = null;

  savedViewService = inject(SavedViewService);
  savedFilterService = inject(SavedFilterService);
  graphqlService = inject(GraphqlService);
  customObjectService = inject(CustomObjectsService);
  projectTemplateService = inject(ProjectTemplateService);
  engagementService = inject(EngagementsService);
  imageService = inject(ImageService);
  apiService = inject(BaseApiService);
  pipelineService = inject(PipelineService);
  httpClient = inject(HttpClient);
}
